import React from 'react';
import cn from 'classnames';
import cls from './RequestMaterialStage.module.css';
import { IRequestMaterialStage } from '@entities/requestMaterial';
import { UiText } from '@shared/ui';
import { RequestMaterialGroup, RequestMaterialPosition } from '@entities/requestMaterial/ui';

interface RequestMaterialStageProps {
    classes?: string;
    stage: IRequestMaterialStage;
}

export const RequestMaterialStage = ({ classes, stage }: RequestMaterialStageProps) => {
    return (
        <div className={cn(cls.RequestMaterialStage, [classes])}>
            <div className={cls.stageTitle}>
                <UiText variant={'plain'} weight={'bold'}>
                    {stage.title}
                </UiText>
            </div>
            {stage.positions.map((position) => (
                <React.Fragment key={position.guid}>
                    {position.type === 'group' ? (
                        <RequestMaterialGroup group={position} />
                    ) : (
                        <RequestMaterialPosition position={position} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
